App.ApplicationView = Em.View.extend
  classNames: ['application-view']